import { render, staticRenderFns } from "./PrintableMessages.vue?vue&type=template&id=64271e2a&scoped=true&lang=pug&"
import script from "./PrintableMessages.vue?vue&type=script&lang=js&"
export * from "./PrintableMessages.vue?vue&type=script&lang=js&"
import style0 from "./PrintableMessages.vue?vue&type=style&index=0&id=64271e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64271e2a",
  null
  
)

export default component.exports